import React from "react";

import { ReactComponent as Manufacturing } from "../../assets/Icons/Manufacturing.svg";
import { ReactComponent as PumpJack } from "../../assets/Icons/PumpJack.svg";
import { ReactComponent as Truck } from "../../assets/Icons/Truck.svg";
import { ReactComponent as Construction } from "../../assets/Icons/Construction.svg";
import { ReactComponent as Utilities } from "../../assets/Icons/Utilities.svg";
import { ReactComponent as Logistics } from "../../assets/Icons/Logistics.svg";

export function Industries(props) {
  return (
    <>
      <h2 className="mediumHeadline textCentre mb-8">
        Industry-Specific Solutions
      </h2>
      <section className="industriesContainer">
        <div className="industryItem">
          <Manufacturing width={50} style={{ fill: "#f1cf32" }} />
          <h3 className="emphasisHeadline">Manufacturing</h3>
          <p className="bodyText">
            Our app helps manufacturers reduce injuries and downtime by
            streamlining safety checks and equipment inspections.
          </p>
        </div>
        <div className="industryItem">
          <PumpJack width={50} style={{ fill: "#f1cf32" }} />

          <h3 className="emphasisHeadline">Oil & Gas</h3>
          <p className="bodyText">
            In oil and gas, our app enables proactive Field Level Hazard
            Identification and compliance tracking in high-risk environments.
          </p>
        </div>
        <div className="industryItem">
          <Construction width={50} style={{ fill: "#f1cf32" }} />

          <h3 className="emphasisHeadline">Construction</h3>
          <p className="bodyText">
            Construction teams use our app to manage on-site inspections, safety
            talks, and incident reporting — all in real time.
          </p>
        </div>
        <div className="industryItem">
          <Truck width={50} style={{ fill: "#f1cf32" }} />

          <h3 className="emphasisHeadline">Transportation</h3>
          <p className="bodyText">
            Our app supports transportation crews with digital pre-trip
            inspections, fatigue monitoring, and mobile compliance tools.
          </p>
        </div>
        <div className="industryItem">
          <Utilities width={40} style={{ fill: "#f1cf32" }} />

          <h3 className="emphasisHeadline">Utilities</h3>
          <p className="bodyText">
            In the high-risk utilities industry, our software helps you
            proactively manage hazards, streamline compliance, and protect
            critical assets and personnel.
          </p>
        </div>

        <div className="industryItem">
          <Logistics width={50} style={{ fill: "#f1cf32" }} />

          <h3 className="emphasisHeadline">Logistics & Warehousing</h3>
          <p className="bodyText">
            Our platform mitigates risks from heavy machinery and dynamic
            environments, ensuring every employee goes home safely while
            enhancing efficiency.
          </p>
        </div>
      </section>
    </>
  );
}
